export default __webpack_public_path__ + "static/media/screen-person.f1a376ff.png";